import request from '@/utils/request'

// 来源渠道列表（启用中，按权重排序）
export function channelList() {
  return request.post('/base/channelList')
}

// 来源渠道管理列表（含停用，仅管理员）
export function channelManage() {
  return request.post('/base/channelManage')
}

// 来源渠道新增/修改：POST id name weigh status
export function channelSave(data) {
  return request.post('/base/channelSave', data)
}

// 来源渠道删除：POST id
export function channelDelete(id) {
  return request.post('/base/channelDelete', { id })
}

// 商品列表（status 可选过滤；建单时用 status=1 只取上架商品）
export function productList(params) {
  return request.get('/base/productList', { params })
}

// 商品新增/修改：POST id name price min_price max_price original_price cover template_id content weigh status
export function productSave(data) {
  return request.post('/base/productSave', data)
}

// 商品删除：POST id
export function productDelete(id) {
  return request.post('/base/productDelete', { id })
}

// 收款平台列表（启用中；manage=1 含停用）
export function paytypeList(params) {
  return request.post('/base/paytypeList', params || {})
}

// 收款平台新增/修改：POST id name rate weigh status remark
export function paytypeSave(data) {
  return request.post('/base/paytypeSave', data)
}

// 收款平台删除：POST id
export function paytypeDelete(id) {
  return request.post('/base/paytypeDelete', { id })
}
